import React from "react";
import { motion } from "framer-motion";

export default function Testimonials({ items = [] }) {
  return (
    <section id="reviews" className="py-16 md:py-24" style={{ background: "var(--ev-bg-2)" }}>
      <div className="mx-auto max-w-[1200px] px-5 md:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <div className="eyebrow">Real stories</div>
          <h2 className="font-serif-ev mt-4 text-4xl sm:text-5xl md:text-6xl leading-[1.02] tracking-tight">
            Over 2,000 lives transformed.
          </h2>
        </div>
      </div>

      <div className="mt-10 md:mt-14 pl-5 md:pl-10">
        <div className="flex gap-5 overflow-x-auto no-scrollbar pr-5 md:pr-10 pb-4 snap-x">
          {items.map((t, i) => (
            <motion.article
              key={t.id}
              initial={{ opacity: 0, y: 12 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.05 }}
              className="ev-card p-6 md:p-8 min-w-[300px] sm:min-w-[380px] md:min-w-[440px] snap-start smooth-hover"
            >
              <p className="text-[15px] md:text-base leading-relaxed" style={{ color: "var(--ev-ink-2)" }}>
                “{t.quote}”
              </p>
              <div className="mt-6 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full grid place-items-center text-white font-medium"
                     style={{ background: "var(--ev-blue)" }}>
                  {t.initial || t.name?.[0]}
                </div>
                <div>
                  <div className="font-medium" style={{ color: "var(--ev-ink)" }}>{t.name}</div>
                  <div className="text-xs" style={{ color: "var(--ev-muted)" }}>Verified client review</div>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
